import { render, staticRenderFns } from "./authCamera.vue?vue&type=template&id=d5250a78&scoped=true&"
import script from "./authCamera.vue?vue&type=script&lang=js&"
export * from "./authCamera.vue?vue&type=script&lang=js&"
import style0 from "./authCamera.vue?vue&type=style&index=0&id=d5250a78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5250a78",
  null
  
)

export default component.exports